import styled from "styled-components";

export const TripCard = styled.div`
  background-color: ${({ theme }) => theme.colors.white};
  border: 1px solid ${({ theme }) => theme.colors.gray200};
  border-radius: ${({ theme }) => theme.radius.lg};
  overflow: hidden;
  cursor: pointer;
  transition: border-color ${({ theme }) => theme.transitions.fast},
    box-shadow ${({ theme }) => theme.transitions.fast};

  &:hover {
    border-color: ${({ theme }) => theme.colors.primary};
    box-shadow: ${({ theme }) => theme.shadows.md};
  }
`;

export const TripCardBody = styled.div`
  padding: ${({ theme }) => theme.space[4]};
`;

export const TripCardTop = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: ${({ theme }) => theme.space[3]};
`;

export const TagBadge = styled.span`
  display: inline-block;
  background-color: ${({ theme }) => theme.colors.primaryBg};
  color: ${({ theme }) => theme.colors.primary};
  font-size: ${({ theme }) => theme.fonts.xs};
  font-weight: 700;
  padding: ${({ theme }) => `${theme.space[1]} ${theme.space[2]}`};
  border-radius: ${({ theme }) => theme.radius.sm};
`;

export const DirectionLabel = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.space[1]};
  font-size: ${({ theme }) => theme.fonts.sm};
  color: ${({ theme }) => theme.colors.gray500};

  svg {
    flex-shrink: 0;
  }
`;

export const RouteSection = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.space[3]};
  margin-bottom: ${({ theme }) => theme.space[3]};
`;

export const TripPoint = styled.div`
  flex: 1;
  min-width: 0;
`;

export const TripPointLabel = styled.span`
  display: block;
  font-size: ${({ theme }) => theme.fonts.xs};
  color: ${({ theme }) => theme.colors.gray400};
  text-transform: uppercase;
  margin-bottom: 2px;
`;

export const TripPointValue = styled.span`
  display: block;
  font-size: ${({ theme }) => theme.fonts.sm};
  font-weight: 500;
  color: ${({ theme }) => theme.colors.gray800};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const RouteArrow = styled.div`
  display: flex;
  align-items: center;
  color: ${({ theme }) => theme.colors.gray400};
  flex-shrink: 0;
  padding-top: ${({ theme }) => theme.space[3]};
`;

export const MetaRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: ${({ theme }) => theme.space[4]};
`;

export const MetaItem = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.space[1]};
  font-size: ${({ theme }) => theme.fonts.xs};
  color: ${({ theme }) => theme.colors.gray500};

  svg {
    flex-shrink: 0;
  }
`;

export const StatusDot = styled.span`
  display: inline-block;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: ${({ $active, theme }) =>
    $active ? theme.colors.successBadge : theme.colors.errorDark};
`;

export const TripCardFooter = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: ${({ theme }) => theme.space[1]};
  padding: ${({ theme }) => `${theme.space[3]} ${theme.space[4]}`};
  border-top: 1px solid ${({ theme }) => theme.colors.gray100};
  background-color: ${({ theme }) => theme.colors.gray50};
`;

export const DayChip = styled.span`
  padding: 2px ${({ theme }) => theme.space[2]};
  border-radius: ${({ theme }) => theme.radius.sm};
  font-size: ${({ theme }) => theme.fonts.xs};
  font-weight: 500;
  background-color: ${({ $active, theme }) =>
    $active ? theme.colors.successLighter : theme.colors.gray100};
  color: ${({ $active, theme }) =>
    $active ? theme.colors.success : theme.colors.gray400};
`;
